"use strict";

import config from '../../configLoader';
import CartPage from "./CartPage";
import GeneralPage from "./GeneralPage";
import ProductPage from "./ProductPage";
import CheckoutPage from "./CheckoutPage";
import InformationPage from "./InformationPage";

let instances = {};

function getExistingInstance(instanceName)
{
    if (instanceName in instances) {
        return instances[instanceName];
    }

    return null;
}

export default function(instanceName, purge = false) {
    let newClass = !purge ? getExistingInstance(instanceName) : null;
    let pageConsts = config("consts.PAGES");

    switch (instanceName) {
        case pageConsts.PRODUCT:
            newClass = newClass || new ProductPage();
            break;
        case pageConsts.GENERAL:
            newClass = newClass || new GeneralPage();
            break;
        case pageConsts.INFORMATION:
            newClass = newClass || new InformationPage();
            break;
        case pageConsts.CART:
            newClass = newClass || new CartPage();
            break;
        case pageConsts.CHECKOUT:
            newClass = newClass || new CheckoutPage();
            break;
    }
    
    if (!newClass) {
        throw new Error(`Could not instantiate ${instanceName}`);
    }

    instances[instanceName] = newClass;
    return newClass;
}

